import React from 'react'
import * as Displays from 'support/displays'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import ViewShiftSmartview from 'widgets/smartviews/shifts/ViewShiftSmartview'
import { useModelKey, ValueToCollection, ForEachModel } from '@morningtrain/react-resources'
import ShiftListCard from 'ui/cards/ShiftListCard'
import ShiftBadges from 'ui/elements/ShiftBadges'
import SlotBadge from 'widgets/shifts/themes/calendar/SlotBadge'
import { TriggerPipelineOnClick } from '@morningtrain/react-pipelines'
import { CallbackOnPipe, Pipeline } from '@morningtrain/react-helpers'
import useActiveShift from 'support/hooks/use-active-shift'
import ExchangeActions from 'widgets/shifts/exchange/ExchangeActions'
import * as UI from 'ui'
import useShiftStatus from 'widgets/shifts/themes/calendar/use-shift-status'
import ExchangeActionsInner from 'widgets/shifts/exchange/ExchangeActionsInner'
import OpenShift from './OpenShift'
import {Env} from "@morningtrain/helpers";

export default function Slot ({ mode = 'view' }) {
  const id = useModelKey()
  const format = 'YYYY-MM-DD HH:mm:ss'

  const [activeShift, setActiveShift] = useActiveShift()

  const { color, status } = useShiftStatus()
  const hasClosingType = Env.get('globals.has_closing_type');

  return (
    <Pipeline>
      <TriggerPipelineOnClick>
        <ShiftListCard
          active={activeShift === id}
          time={<><Displays.Time name='start_at' forceUTC parseFormat={format} /> - <Displays.Time name='end_at' forceUTC parseFormat={format} /></>}
          name={<OpenShift/>}
          job={<Displays.Text name='user.employment_name' />}
          avatar={<Displays.Image name='user.avatar_url' />}
          button={<ExchangeActionsInner fullWidth={false} className='w-80 pl-2 exchange-actions' />}
          text={hasClosingType === 1 ? <Displays.Enum name='closing_type' enum='closing_type' /> : ''}
          color={color}
          shiftState={status}
        >
          <div className='flex space-x-4 items-center'>
            <div className='w-36'>
              <ValueToCollection name='user.active_badges'>
                <ShiftBadges>
                  <ForEachModel>
                    <SlotBadge gray big />
                  </ForEachModel>
                </ShiftBadges>
              </ValueToCollection>
            </div>
            <UI.Text block className='text-sm max-w-4xs xl:max-w-2xs'>
              <Displays.Text name='note' />
            </UI.Text>
          </div>
        </ShiftListCard>
      </TriggerPipelineOnClick>
      <CallbackOnPipe callback={() => { setActiveShift(id) }} />
      <MountSmartviewOnPipe smartview={<ViewShiftSmartview mode='view' />} replace={false} />
    </Pipeline>
  )
}
